import axios from 'axios';

export async function getAssistsLeagueTable(league_pk) {


  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/leaderboards/league/${league_pk}/league_leaderboard/assists/`,

    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

